import * as React from 'react';
import type { YoAuthUser } from '../types';
import { useContext } from 'react';

export const AuthUserContext = React.createContext<YoAuthUser | null>(null);

export const useAuthUser = () => useContext(AuthUserContext);
